import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

export const GAHTIntake_ID = 'imago.gaht.intake-form' as EMRTypeID & EMRKindID
